import { BrowserRouter, Routes, Route, NavLink, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { 
  House, 
  UploadSimple, 
  ChatCircleDots, 
  Funnel, 
  Export, 
  Gear,
  Database,
  Robot,
  Star,
  Brain
} from "@phosphor-icons/react";
import "./App.css";

// Pages
import Dashboard from "./pages/Dashboard";
import Upload from "./pages/Upload";
import Conversations from "./pages/Conversations";
import Processing from "./pages/Processing";
import ExportPage from "./pages/Export";
import Settings from "./pages/Settings";
import QualityScoring from "./pages/QualityScoring";
import Training from "./pages/Training";

const navItems = [
  { path: "/", icon: House, label: "Dashboard" },
  { path: "/upload", icon: UploadSimple, label: "Upload" },
  { path: "/conversations", icon: ChatCircleDots, label: "Conversations" },
  { path: "/processing", icon: Funnel, label: "Processing" },
  { path: "/quality", icon: Star, label: "Quality" },
  { path: "/training", icon: Brain, label: "Training" },
  { path: "/export", icon: Export, label: "Export" },
  { path: "/settings", icon: Gear, label: "Settings" },
];

const Sidebar = () => {
  const location = useLocation();
  
  return (
    <aside className="sidebar" data-testid="sidebar">
      <div className="p-6 border-b border-zinc-800">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md bg-blue-600 flex items-center justify-center">
            <Database weight="bold" className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="font-semibold text-zinc-100 tracking-tight">DataForge</h1>
            <p className="text-xs text-zinc-500">AI Training Prep</p>
          </div>
        </div>
      </div>
      
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map(({ path, icon: Icon, label }) => (
          <NavLink
            key={path}
            to={path}
            data-testid={`nav-${label.toLowerCase()}`}
            className={`sidebar-item ${location.pathname === path ? 'active' : ''}`}
          >
            <Icon weight={location.pathname === path ? "fill" : "regular"} className="w-5 h-5" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      
      <div className="p-4 border-t border-zinc-800">
        <div className="flex items-center gap-3 px-3 py-2 bg-zinc-800/50 rounded-md">
          <Robot weight="duotone" className="w-5 h-5 text-cyan-400" />
          <div className="flex-1 min-w-0">
            <p className="text-xs text-zinc-400 truncate">Ollama Status</p>
            <p className="text-xs font-medium text-zinc-300">Check Settings</p>
          </div>
        </div>
      </div>
    </aside>
  );
};

const PageHeader = ({ title, subtitle }) => {
  return (
    <header className="sticky-header px-8 py-4">
      <h2 className="text-xl font-semibold text-zinc-100">{title}</h2>
      {subtitle && <p className="text-sm text-zinc-500 mt-0.5">{subtitle}</p>}
    </header>
  );
};

function App() {
  return (
    <BrowserRouter>
      <div className="app-layout">
        <Sidebar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/conversations" element={<Conversations />} />
            <Route path="/processing" element={<Processing />} />
            <Route path="/quality" element={<QualityScoring />} />
            <Route path="/training" element={<Training />} />
            <Route path="/export" element={<ExportPage />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </BrowserRouter>
  );
}

export { PageHeader };
export default App;
